import { render, staticRenderFns } from "./TestCallDialog.vue?vue&type=template&id=3b2c5018&scoped=true&"
import script from "./TestCallDialog.vue?vue&type=script&lang=ts&"
export * from "./TestCallDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TestCallDialog.vue?vue&type=style&index=0&id=3b2c5018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2c5018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
